import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUp } from "lucide-react";

export function BackToTop() {
  const loc = useLocation();
  const [show, setShow] = useState(false);
  const hidden = loc.pathname.startsWith("/admin");

  useEffect(() => {
    const h = () => setShow(window.scrollY > 800);
    window.addEventListener("scroll", h);
    h();
    return () => window.removeEventListener("scroll", h);
  }, []);

  if (hidden) return null;

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.2 }}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="back-to-top"
          aria-label="Back to top"
          className="fixed bottom-20 right-4 z-[45] flex h-11 w-11 items-center justify-center rounded-full bg-[#2C2B2C]/90 text-[#FFFCFA] shadow-[0_10px_25px_-8px_rgba(0,0,0,0.5)] backdrop-blur-sm transition-colors hover:bg-[#2C2B2C] md:hidden">
          <ArrowUp className="h-5 w-5" />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
